export default[
    {
        path: '/trabalhador/lista',
        name: 'lista de trabalhadores', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/trabalhador/cadastro',
        name: 'cadastro do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/trabalhador/editar/:id',
        name: 'editar trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
    {
        path: '/trabalhador/perfil/:id',
        name: 'perfil do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/perfil.vue')
    },
]